import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取分公司元素分块信息列表
export function getBranchElementBlockList(params) {
  return request({
    url: URL.sys.getBranchElementBlockList,
    method: 'get',
    params
  })
}

// 保存UI自定义信息
export function saveUICustom(data) {
  return request({
    url: URL.sys.saveUICustom,
    method: 'post',
    data
  })
}

// 获取UI自定义页面信息列表
export function getUiCustomPageList(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getUiCustomPageList,
    method: 'post',
    data
  })
}

// 获取操作指令管理信息
export function getInstructionManage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getInstructionManage,
    method: 'post',
    data
  })
}

// 保存操作指令管理信息
export function saveInstructionManage(data) {
  return request({
    url: URL.sys.saveInstructionManage,
    method: 'post',
    data
  })
}

// 获取业务操作指令列表
export function getJobInstructions(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getJobInstructions,
    method: 'post',
    data
  })
}

// 获取操作指令列表
export function getInstructions(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getInstructions,
    method: 'post',
    data
  })
}

// 获取业务类型岗位信息列表
export function getLobPositionList(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getLobPositionList,
    method: 'post',
    data
  })
}

// 获取元素权限管理信息
export function getElementPermissionManage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getElementPermissionManage,
    method: 'post',
    data
  })
}

// 保存元素权限管理信息
export function saveElementPermissionManage(data) {
  return request({
    url: URL.sys.saveElementPermissionManage,
    method: 'post',
    data
  })
}

// 获取用户元素分块信息列表
export function getUserElementBlockList(params) {
  return request({
    url: URL.sys.getUserElementBlockList,
    method: 'get',
    params
  })
}

// 保存用户元素分块信息
export function saveUserBlocks(data) {
  return request({
    url: URL.sys.saveUserBlocks,
    method: 'post',
    data
  })
}

// 获取页签设置信息
export function getPageSets(pageTypes) {
  return request({
    url: URL.sys.getPageSets,
    method: 'post',
    data: pageTypes
  })
}

// 保存页签设置信息
export function savePageSet(list) {
  return request({
    url: URL.sys.savePageSet,
    method: 'post',
    data: list
  })
}

// 获取字段值同步管理信息
export function getValueSyncManage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getValueSyncManage,
    method: 'post',
    data
  })
}

// 保存字段值同步管理
export function saveValueSyncManage(data) {
  return request({
    url: URL.sys.saveValueSyncManage,
    method: 'post',
    data
  })
}

// 获取付款申请设置信息
export function getBillPaymentSetting(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getBillPaymentSetting,
    method: 'post',
    data
  })
}

// 获取付款申请设置信息
export function getBranchBillPaymentSetting(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getBranchBillPaymentSetting,
    method: 'post',
    data
  })
}

// 保存付款申请设置信息
export function saveBillPaymentSetting(data) {
  return request({
    url: URL.sys.saveBillPaymentSetting,
    method: 'post',
    data
  })
}

// 获取付款申请规则设置信息
export function getBillPaymentRuleSetting(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getBillPaymentRuleSetting,
    method: 'post',
    data
  })
}

// 获取分公司付款申请规则设置信息
export function getBranchBillPaymentRuleSetting(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.sys.getBranchBillPaymentRuleSetting,
    method: 'post',
    data
  })
}

// 保存付款申请规则设置信息
export function saveBillPaymentRuleSetting(data) {
  return request({
    url: URL.sys.saveBillPaymentRuleSetting,
    method: 'post',
    data
  })
}

// 指令数据推送接口
export function instructionPushInfo(data) {
  return request({
    url: URL.act.apiInterface.instructionPushInfo,
    method: 'post',
    data
  })
}
